module.exports = __webpack_public_path__ + "img/tool1.4d666c23.png";